(() => {
  const initializePawTrail = (section) => {
    const layer = section.querySelector('.ft-product-showcase__paw-trails');
    if (!layer || section.dataset.pawTrailInitialized === 'true') return;

    section.dataset.pawTrailInitialized = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const pawPrints = [];
    const rotations = [-18, 16, -14, 20, -12, 18, -16, 14];
    const sizes = [18, 20, 19, 21];
    const stepDistance = 38;
    const maximumPawPrints = 22;
    let pawIndex = 0;
    let lastPoint = null;

    const removePawPrint = (pawRecord) => {
      window.clearTimeout(pawRecord.fadeTimer);
      window.clearTimeout(pawRecord.removeTimer);
      pawRecord.element.remove();
      const pawRecordIndex = pawPrints.indexOf(pawRecord);
      if (pawRecordIndex !== -1) pawPrints.splice(pawRecordIndex, 1);
    };

    const createPawPrint = (point, directionX, directionY) => {
      if (pawPrints.length >= maximumPawPrints) removePawPrint(pawPrints[0]);

      const layerRect = layer.getBoundingClientRect();
      const behindDistance = 30 + Math.random() * 15;
      const sideOffset = pawIndex % 2 === 0 ? -6 : 6;
      const paw = document.createElement('span');
      const rotation = rotations[pawIndex % rotations.length] + (Math.random() * 4 - 2);
      const size = sizes[Math.floor(Math.random() * sizes.length)];
      const x = point.x - layerRect.left - directionX * behindDistance - directionY * sideOffset;
      const y = point.y - layerRect.top - directionY * behindDistance + directionX * sideOffset;

      paw.className = 'ft-product-showcase__paw-print';
      paw.style.left = `${x - size / 2}px`;
      paw.style.top = `${y - size / 2}px`;
      paw.style.setProperty('--ft-paw-size', `${size}px`);
      paw.style.setProperty('--ft-paw-rotation', `${rotation}deg`);
      layer.appendChild(paw);
      window.requestAnimationFrame(() => paw.classList.add('is-visible'));

      const pawRecord = { element: paw, fadeTimer: null, removeTimer: null };
      const holdTime = 3500 + Math.random() * 1000;
      pawRecord.fadeTimer = window.setTimeout(() => {
        if (!paw.isConnected) return;
        paw.classList.add('is-fading');
        pawRecord.removeTimer = window.setTimeout(() => removePawPrint(pawRecord), 900);
      }, holdTime);
      pawPrints.push(pawRecord);
      pawIndex += 1;
    };

    const addPawPrint = (event) => {
      const currentPoint = { x: event.clientX, y: event.clientY };

      if (!lastPoint) {
        lastPoint = currentPoint;
        return;
      }

      let deltaX = currentPoint.x - lastPoint.x;
      let deltaY = currentPoint.y - lastPoint.y;
      let distance = Math.hypot(deltaX, deltaY);
      if (distance < stepDistance) return;

      const directionX = deltaX / distance;
      const directionY = deltaY / distance;

      while (distance >= stepDistance) {
        lastPoint = {
          x: lastPoint.x + directionX * stepDistance,
          y: lastPoint.y + directionY * stepDistance
        };
        createPawPrint(lastPoint, directionX, directionY);
        deltaX = currentPoint.x - lastPoint.x;
        deltaY = currentPoint.y - lastPoint.y;
        distance = Math.hypot(deltaX, deltaY);
      }
    };

    const startTracking = (event) => {
      lastPoint = { x: event.clientX, y: event.clientY };
      section.addEventListener('mousemove', addPawPrint);
    };

    const stopTracking = () => {
      section.removeEventListener('mousemove', addPawPrint);
      lastPoint = null;
    };

    section.addEventListener('mouseenter', startTracking);
    section.addEventListener('mouseleave', stopTracking);
  };

  const initializeProductShowcase = (section) => {
    if (!section || section.dataset.productShowcaseAnimationInitialized === 'true') return;

    section.dataset.productShowcaseAnimationInitialized = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    section.classList.add('is-animation-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        section.classList.add('is-visible');
        observer.unobserve(section);
      },
      { threshold: 0.55, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(section);
  };

  const initializeAllProductShowcases = (root = document) => {
    root.querySelectorAll('.ft-product-showcase').forEach((section) => {
      initializeProductShowcase(section);
      initializePawTrail(section);
    });
  };

  initializeAllProductShowcases();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllProductShowcases(event.target);
  });
})();
